export const ANALYTICS_COLORS = {
    completion: "#16a34a",
    mastery: "#0f766e",
    scaffoldingLow: "#60a5fa",
    scaffoldingMed: "#f59e0b",
    scaffoldingHigh: "#ef4444",
    risk: "#dc2626",
    warning: "#d97706",
    waste: "#e11d48",
    neutral: "#64748b",
    muted: "#94a3b8",
    info: "#2563eb",
    trendFill: "rgba(37, 99, 235, 0.12)",
    grid: "hsl(20 5.9% 90%)",
} as const;

export const ANALYTICS_SERIES = {
    sessions: "#2563eb",
    completion: "#16a34a",
    accuracy: "#14b8a6",
    mastery: "#0f766e",
    time: "#f59e0b",
    scaffolding: "#ef4444",
    waste: "#e11d48",
} as const;

export const ANALYTICS_BADGE_STYLES = {
    success: "bg-emerald-50 text-emerald-700 border-emerald-200",
    warning: "bg-amber-50 text-amber-700 border-amber-200",
    danger: "bg-rose-50 text-rose-700 border-rose-200",
    info: "bg-blue-50 text-blue-700 border-blue-200",
    neutral: "bg-slate-50 text-slate-700 border-slate-200",
} as const;
